export const getRfidWebSocketUrl = () => {
  const configuredUrl = process.env.REACT_APP_RFID_WS_URL?.trim();
  if (configuredUrl) return configuredUrl;

  const isLocalFrontend = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  if (isLocalFrontend) return "ws://localhost:8386/rfid";

  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${window.location.host}/rfid`;
};
